<template>
    <div class="app-layout"
         :class="{'user-authenticated': authenticated, 'user-not-authenticated': !authenticated }">
        <div class="header-background"></div>
        <div class="header d-flex flex-column">
            <div class="w-100 text-right">
                <LocaleDropdown class="position-absolute right-locale" :right="true"/>
            </div>
        </div>
        
        <div class="container ml-0 pb-2">
            <div class="col-lg-8 m-auto">
            <div>
                <a href="/" class="logo-1">
                    <img src="/images/acnenext.jpg" alt="acnenext">
                </a>
            </div>
            </div>
        </div>

        <div class="container ml-0 pb-2" id="content">

            <o-child/>
        </div>
        <div class="container ml-0 pb-2">
            <div class="col-lg-8 m-auto">
                <div class="row">
                    <div class="col">
                        {{$t('medtastic.copyright')}} © {{year}} Acnenext
                    </div>
                    <div class="col text-right">
                        <a href="/documents/data-privacy-statement.pdf">{{$t('medtastic.data_privacy_statement')}}</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import LocaleDropdown from '~/components/LocaleDropdown'

  export default {
    name: 'app-layout',

    data: () => ({
      sidebarVisible: false
    }),

    components: {
      LocaleDropdown
    },

    computed: {
      ...mapGetters({
        authenticated: 'auth/check'
      }),
      year() {
        var d = new Date()
        return d.getFullYear()
      }
    }
  }
</script>
